import React from 'react';
import { Col } from 'react-bootstrap';

function WeatherCard({details}) {
    return (
        <Col sm={12} md={6} lg={4} className='weather-card'>
            <p className='p-0 m-0'>{details.name}</p>
            <p className='p-0 m-0'>{details.value1}</p>
            <p className='p-0 m-0'>{details.value2}</p>
        </Col>
    );
}

export default WeatherCard;